export const PASSKEY_NUDGE_EXPERIMENT_KEY = 'secu-0002';
export const PASSKEY_GROUP_CONTROL = 'control';
export const PASSKEY_GROUP_VARIATION = 'variation';